import { render, staticRenderFns } from "./setType3Template.vue?vue&type=template&id=d63f2f96&scoped=true"
import script from "./setType3Template.vue?vue&type=script&lang=js"
export * from "./setType3Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63f2f96",
  null
  
)

export default component.exports